import { createFileRoute, redirect } from "@tanstack/react-router"

export const Route = createFileRoute("/_dashboard/lender")({
  beforeLoad: ({ context: { store } }) => {
    if (store.getState().userRole !== "lender") {
      throw redirect({ to: "/" })
    }
  },
})
